module.exports = __webpack_public_path__ + "img/MSME.cfe74404.svg";